/**
 * @flow weak
 */
import { eventChannel } from 'redux-saga';
import { put, all, select, take, takeEvery } from 'redux-saga/effects';

// Helpers
import { loadLocaleData } from '../../lib/locale-loader';
import { updateProfile } from '../../lib/api-helper';

// Getters
import { getUsersLocale } from '../session/getters';

// Constants
import { SESSION_FETCH_SUCCESS } from '../session/actions';
export const CHANGE_LOCALE_PENDING = 'CHANGE_LOCALE_PENDING';
export const CHANGE_LOCALE_SUCCESS = 'CHANGE_LOCALE_SUCCESS';
export const CHANGE_LOCALE_ERROR = 'CHANGE_LOCALE_ERROR';
export const LOCAL_STORAGE_LOCALE = 'locale';

export function loadLocale(locale) {
  return loadLocaleData(locale).then(([locale, messages]) => {
    return { locale, messages };
  });
}

export const switchLocale = (locale) => {
  return {
    type: CHANGE_LOCALE_PENDING,
    locale
  };
};

// On every 'CHANGE_LOCALE_PENDING' action (from the locale DDL in the footer)
// or 'SESSION_FETCH_SUCCESS' action (on app init (current_user/exchange))
// run the `changeLocale` function below.
export function* changeLocalePending() {
  yield all([
    takeEvery(CHANGE_LOCALE_PENDING, changeLocale),
    takeEvery(SESSION_FETCH_SUCCESS, changeLocale)
  ]);
}

export function* changeLocale({ locale })  {
  try {
    const sessionLocale = yield select(getUsersLocale);

    let localeToUse = locale;

    if (sessionLocale && !locale) {
      localeToUse = sessionLocale; // Set locale from user session
    }

    const data = yield loadLocale(localeToUse);

    yield put({ type: CHANGE_LOCALE_SUCCESS, messages: data.messages, locale: data.locale });
    // save our new value to localStorage
    localStorage.setItem(LOCAL_STORAGE_LOCALE, data.locale);

    if (sessionLocale && locale) {
      yield updateProfile(data.locale); // If user session and user changed locale - save to profile
    }
  }
  catch (error) {
    yield put({ type: CHANGE_LOCALE_ERROR, error });
  }
}

// This is a little weird - setupLocalStorageLocalChange
// is called from our rootSaga, so this gets called on app init.
// From here, we create a 'channel' which will listen to all
// callback events from window.addEventListener('storage', ...);
// Inside the callback, we can use a special function (emitter)
// to send those callback events back into our redux-saga
// land where we use generators to fire actions/events.
// We have to do this since, a callback to window.addEventListener
// expects an old school function, or an arrow funciton, which cannot
// interact with generators in anyway.
export function* setupLocalStorageLocaleChange() {
  yield localStorageChannel();
}

// respond to locale updates from other tabs
export function* localStorageChannel() {
  const channel = eventChannel(emitter => {
    window.addEventListener('storage', function(storageEvent) {
      if (storageEvent.key === LOCAL_STORAGE_LOCALE) {
        emitter(storageEvent.newValue);
      }
    });
    return () => null;
  });

  while (true) {
    const newLocaleValue = yield take(channel);
    yield changeLocale({ locale: newLocaleValue });
  }
}



// WEBPACK FOOTER //
// ./src/modules/locale/actions.js